import HeaderFooterLayout from 'layouts/HeaderFooterLayoutTnC';
import React from 'react';
import PolicyScreen from 'components/PolicyScreen';

const PolicyScreenPageNew = ({ ...props }) => {
  return (
    <div>
      <HeaderFooterLayout>
        <PolicyScreen {...props} />
      </HeaderFooterLayout>
    </div>
  );
};

export default PolicyScreenPageNew;
